import Vue from 'vue'
import ECSite from './EC-Site.vue'
import router from './router'
import store from './store'
import i18n from './assets/lang/i18n'
import UrlConstants from './assets/const/UrlConstants';
import Constants from './assets/const/Constants';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BootstrapVue from 'bootstrap-vue';
import vueHeadful from 'vue-headful';
import LoadScript from 'vue-plugin-load-script';

Vue.use(BootstrapVue);
Vue.use(LoadScript);
Vue.component('vue-headful', vueHeadful);
Vue.config.productionTip = false;
Vue.prototype.$log = console.log.bind(console);
Vue.prototype.$UrlConstants = UrlConstants;
Vue.prototype.$Constants = Constants;

new Vue({
  router,
  store,
  i18n,
  render: h => h(ECSite)
}).$mount('#EC-Site')
